import * as React from "react";
import {Trans, useTranslation} from "@unibuddy/intl";
import styled from "styled-components";
import {Box} from "@unibuddy/patron";

import {ThemedLink} from "../../../../components/ThemedLink/ThemedLink";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_UPDATED_UNIBUDDY_POLICY} from "../../../../translations/privacy-text";

const PRIVACY_POLICY = "https://unibuddy.com/privacy-policy/";
const TERMS_OF_USE = "https://unibuddy.com/terms-of-use/";

const StyledBox = styled(Box)`
    text-align: center;
    font-size: 0.875rem;
`;

export const UnibuddyPolicyText: React.FC = () => {
    const {t} = useTranslation(IntlNamespaces.PRIVACY_TEXT);

    return (
        <StyledBox display="block">
            <Trans t={t} i18nKey={INTL_UPDATED_UNIBUDDY_POLICY.key}>
                {"By signing up you agree to Unibuddy’s "}
                <ThemedLink external to={PRIVACY_POLICY} target="_blank">
                    Privacy Policy
                </ThemedLink>
                {" and "}
                <ThemedLink external to={TERMS_OF_USE} target="_blank">
                    Terms of Use
                </ThemedLink>
            </Trans>
        </StyledBox>
    );
};
